export const PLACEMENTS_3_CONSTANTS = {
  METADATA_TITLES: {},

  PLACEMENTS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "row1_image",
      label: "Row 1 Image (logo strip)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload strip image (logos in one row); ensure background matches section color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "row1_scroll_frequency",
      label: "Row 1 Scroll Frequency (ms)",
      value: "3000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "(e.g. 3000)",
      required: false,
      defaultValue: "3000",
    },
    {
      fieldName: "row1_scroll_direction",
      label: "Row 1 Scroll Direction",
      value: "left",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Direction",
      required: false,
      defaultValue: "left",
      options: [
        { label: "Left", value: "left" },
        { label: "Right", value: "right" },
      ],
    },
    {
      fieldName: "row2_image",
      label: "Row 2 Image (logo strip)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload strip image; ensure background matches section color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "row2_scroll_frequency",
      label: "Row 2 Scroll Frequency (ms)",
      value: "3000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "(e.g. 3000)",
      required: false,
      defaultValue: "3000",
    },
    {
      fieldName: "row2_scroll_direction",
      label: "Row 2 Scroll Direction",
      value: "right",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Direction",
      required: false,
      defaultValue: "right",
      options: [
        { label: "Left", value: "left" },
        { label: "Right", value: "right" },
      ],
    },
    {
      fieldName: "status",
      label: "Placements Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Placements Section",
      defaultValue: false,
    },
  ],
};
